module.exports = __webpack_public_path__ + "img/IMG_9786_L_BlackMatted.961a1208.jpg";